import React from 'react';
import Proptypes from 'prop-types';
import { Visibility, Text, Spacing } from '@reservamos/elements';
import { useTranslation } from 'react-i18next';

const PassengersList = ({ passengers }) => {
  const { t } = useTranslation('exchange');
  const { t: tSeats } = useTranslation('seats');

  /**
   * Set the category of the passenger
   * @param {Object} passenger - The passenger object
   * @returns {string} - The category of the passenger
   */
  const setCategory = (passenger) => {
    if (passenger.isAdjacentSeat) {
      return 'adjacent_seat';
    }
    return passenger.category;
  };

  return passengers.map((passenger, index) => (
    <div className="passenger-container" key={passenger.id}>
      <Spacing vertical size="XS">
        <Visibility type="hideForMedium">
          <Text weight="bold" size="S">
            {t('labels.passenger')} {index + 1}
          </Text>
        </Visibility>
        <Text key={passenger.id} weight="semibold" size="L" mobileSize="S">
          {passenger.firstName} {passenger.lastName} {passenger.secondLastName}
          {passenger.category && (
            <Text elementType="span" key={passenger.id} weight="regular" size="S">
              - {tSeats(`passengers:type.${setCategory(passenger)}`)}
            </Text>
          )}
        </Text>
      </Spacing>
    </div>
  ));
};

PassengersList.protoTypes = {
  passengers: Proptypes.array,
};

export default PassengersList;
